exports = module.exports = require("./../../../node_modules/custom-react-scripts/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._20WPQbZU89icT3LLICmd41{max-width:40em;margin:0 auto;padding:1em;text-align:center}", ""]);

// exports
exports.locals = {
	"section": "_20WPQbZU89icT3LLICmd41"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/custom-react-scripts/~/css-loader?modules&-autoprefixer&importLoaders=1!./~/custom-react-scripts/~/postcss-loader!./src/components/section/style.css
 ** module id = 352
 ** module chunks = 0
 **/